import React, {useState, useEffect} from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import trackAnalytics from '../../utils/gaia/trackAnalytics';
import {getLocalStorageItem, setLocalStorageItem} from '../../utils/localStorage';
import {SUMMER_1} from '../../colors';
import theme from '../../theme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {makeStyles} from '@material-ui/core/styles';

const useButtonClasses = makeStyles({
    root: {
        '&:hover': {
            color: 'inherit !important',
        },
    }
});

export default function HeaderAnnouncement() {
    const localStorageKey = 'announcement__winter2019';

    const [isOpenState, setIsOpenState] = useState<boolean>(
        getLocalStorageItem(localStorageKey, true)
    );

    useEffect(() => setLocalStorageItem(localStorageKey, isOpenState), [isOpenState]);

    const isNarrow = useMediaQuery(theme.breakpoints.down('xs'));

    const isOpen = window.location.pathname !== '/user/gift/' && isOpenState;

    const buttonClasses = useButtonClasses();

    return <Collapse in={isOpen}>
        <Paper
            square
            style={{
                backgroundColor: SUMMER_1,
                color: '#fff',
                paddingTop: theme.spacing(1.5),
                paddingBottom: theme.spacing(1.5),
                paddingLeft: 51,
                paddingRight: 51,
                display: 'flex',
                alignItems: isNarrow ? 'center' : 'baseline',
                justifyContent: 'center',
                flexDirection: isNarrow ? 'column' : 'row',
            }}
        >
            <IconButton
                style={{position: 'absolute', right: theme.spacing(1), alignSelf: 'center'}}
                color="inherit"
                onClick={() => setIsOpenState(false)}
            >
                <CloseIcon />
            </IconButton>

            <span style={{fontSize: 15}}>
                Give the gift of adventure this season.
            </span>

            <Button
                classes={buttonClasses}
                component='a'
                size='medium'
                style={{
                    fontSize: 13,
                    marginLeft: isNarrow ? 0 : theme.spacing(2),
                    marginTop: isNarrow ? theme.spacing(2) : 0,
                }}
                variant='outlined'
                color="inherit"
                onClick={() => {
                    trackAnalytics('Click Gift Banner', {category: 'Commerce'});
                    setIsOpenState(false);
                }}
                href="/user/gift/"
            >
                Send a Gift Membership
            </Button>
        </Paper>
    </Collapse>;
}
